import * as React from "react";
import styled, { css, keyframes } from "react-emotion";

const spinKeyFrame = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const spinnerStyle = css`
  animation: 400ms linear infinite ${spinKeyFrame};
  border-bottom: 2px solid transparent;
  border-left: 2px solid #89d2d3;
  border-radius: 50%;
  border-right: 2px solid transparent;
  border-top: 2px solid #89d2d3;
  box-sizing: border-box;
  height: 100px;
  width: 100px;
`;

const SpinnerParent = styled("div")`
  display: ${(props) => (props.hidden ? "flex" : "none")};
  position: fixed;
  justify-content: center;
  align-items: center;
  z-index: 100000000000000;
  background: rgba(206, 204, 204, 0.9);
  height: 100%;
  width: 100%;
`;

const Spinner = ({ progress, onClick }) => {
  return (
    <SpinnerParent hidden={progress}>
      <div className={spinnerStyle} onClick={onClick} />
    </SpinnerParent>
  );
};

export default Spinner;
